"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStage = exports.Stage = exports.StageContext = void 0;

var _react = _interopRequireWildcard(require("react"));

var PIXI = _interopRequireWildcard(require("pixi.js"));

var _Container = require("./Container");

var _hooks = require("./hooks");

var _Renderer = require("./Renderer");

var _Ticker = require("./Ticker");

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var StageContext = _Container.ContainerContext; // `Stage` is just alias of `Container`

exports.StageContext = StageContext;

var Stage = function Stage(_ref) {
  var children = _ref.children;
  var container = (0, _hooks.useCloseable)(function () {
    return new PIXI.Container();
  });
  return _react.default.createElement(StageContext.Provider, {
    value: container
  }, children);
};

exports.Stage = Stage;
var useStage = _Container.useContainer;
/** `LazyRefresh` would refresh the `stage` only if the node was re-rendered. */

exports.useStage = useStage;

Stage.LazyRefresh = function () {
  var stage = useStage();
  var renderer = (0, _Renderer.useRenderer)();
  var ticker = (0, _Ticker.useTicker)();
  var subRef = (0, _react.useRef)(null);
  subRef.current = ticker.once(function () {
    return renderer.render(stage);
  });
  (0, _react.useEffect)(function () {
    return function () {
      subRef.current && subRef.current.unsubscribe();
    };
  }, []);
  return null;
};

Stage.LazyRefresh.displayName = 'Stage.LazyRefresh'; // eslint-disable-line @typescript-eslint/no-explicit-any

/** `TickRefresh` would refresh the `stage` each time the ticker frame updated. */

Stage.TickRefresh = function () {
  var stage = useStage();
  var renderer = (0, _Renderer.useRenderer)();
  var ticker = (0, _Ticker.useTicker)();
  (0, _react.useEffect)(function () {
    var sub = ticker.each(function () {
      return renderer.render(stage);
    });
    return function () {
      return sub.unsubscribe();
    };
  }, []);
  return null;
};

Stage.TickRefresh.displayName = 'Stage.TickRefresh'; // eslint-disable-line @typescript-eslint/no-explicit-any